
import exchangeBuffer from '~/helpers/exchangeBuffer';

export default {
    name: 'PopUpShare',

    computed: {
        isOpen() {
            return this.$store.state['pop-up-share']?.isOpen;
        },
        shareLinks() {
            const url = this.$store.state['pop-up-share']?.url;
            const title = this.$store.state['pop-up-share']?.title;

            const list = [
                {
                    type: 'link',
                    link: `https://wa.me/?text=${title}%20${url}`,
                    icon: require('~/assets/img/svg/share/whatsap.svg'),
                    title: 'WhatsApp',
                },
                {
                    type: 'link',
                    link: `https://t.me/share/url?url=${url}&text=${title}`,
                    icon: require('~/assets/img/svg/share/telegram.svg'),
                    title: 'Telegram',
                },
                {
                    type: 'link',
                    link: `http://vk.com/share.php?url=${url}&title=${title}`,
                    icon: require('~/assets/img/svg/share/vk.svg'),
                    title: 'VK',
                },
                {
                    type: 'link',
                    link: `https://connect.ok.ru/offer?url=${url}&title=${title}`,
                    icon: require('~/assets/img/svg/share/ok.svg'),
                    title: 'OK',
                },
            ];

            return list;
        },
        shareUrl() {
            return this.$store.state['pop-up-share']?.url;
        },
    },

    methods: {
        closePopUp() {
            this.$store.commit('pop-up-share/close');
        },
        copyLink() {
            const url = this.$store.state['pop-up-share']?.url;
            exchangeBuffer(url);
            this.$toast.success('Ссылка скопирована');
            this.closePopUp();
        },
    },
};
